import { Localization } from '@material-ui/core/locale';
export * from '@material-ui/core/locale';
import { ptBR as fix } from '@material-ui/core/locale';
import deepmerge from 'deepmerge';

export const ptBR: Localization = deepmerge(fix, {
    props: {
        MuiTablePagination: {
            labelDisplayedRows: ({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`,
        },
    },
});

export const enUS: Localization = {
    props: {
        MuiBreadcrumbs: {
            expandText: 'Show path',
        },
        MuiTablePagination: {
            backIconButtonText: 'Previous page',
            labelRowsPerPage: 'Rows per page:',
            labelDisplayedRows: ({ from, to, count }) => `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`,
            nextIconButtonText: 'Next page',
        },
        MuiRating: {
            getLabelText: (value) => `${value} Star${value !== 1 ? 's' : ''}`,
            emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: 'Clear',
            closeText: 'Close',
            loadingText: 'Loading…',
            noOptionsText: 'No options',
            openText: 'Open',
        },
        MuiAlert: {
            closeText: 'Close',
        },
        MuiPagination: {
            'aria-label': 'Pagination navigation',
            getItemAriaLabel: (type, page, selected) => {
                if (type === 'page') {
                    return `${selected ? '' : 'Go to '}page ${page}`;
                }
                if (type === 'first') {
                    return 'Go to first page';
                }
                if (type === 'last') {
                    return 'Go to last page';
                }
                if (type === 'next') {
                    return 'Go to next page';
                }
                if (type === 'previous') {
                    return 'Go to previous page';
                }
                return '';
            },
        },
    },
};
